export default __webpack_public_path__ + "static/media/IconDesc_EncasedPlutoniumCell.256.a0199349.png";